import React from 'react';
import {
    Layout,
    message,
    Button,
    Form,
    Row,
    Col,
    Input
} from "antd";
import img from '../../assets/img/Illustratiion.png';
import MiCompAPI from "./../../util/api";
const { Content } = Layout;
class FD extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            settings: null,
        };
        this.api = new MiCompAPI(this.props.userPermandMasters);
    }
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.api.invoke(
                    "ResetPassword",
                    "post",
                    (data, success) => {
                        if (success) {
                            if (data.statusCode === 200) {
                                this.props.form.resetFields();
                                message.destroy();
                                message.success(data.statusMessage, 3);
                            } else {
                                message.destroy();
                                message.success(data.statusMessage, 3);
                            }
                        }
                    },
                    values
                );
            }
        });
    }
    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        return (
            <Content>
                <div className="mi_main_div">
                    <div className="mi_main" style={{marginTop:"15px"}} >
                        <Row>
                            <Col span={6}></Col>
                            <Col span={12}>
                                <p className='mi_title' style={{margin:"5px 0px 9px 13px",}}>Change Password</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6} sm={24}></Col>
                            <Col md={12} sm={24}>
                                <Form onSubmit={this.handleSubmit} layout="vertical" hideRequiredMark>
                                    <Row span={24}>
                                        <Col sm={24}>
                                            <Form.Item>
                                                <fieldset className="mi_input_pop">
                                                    <legend className="legend-font">Old Password  </legend>
                                                    {getFieldDecorator('oldpassword', {
                                                        rules: [{ required: true, message: 'Please enter old password.' }],
                                                    })(<Input.Password autoComplete={"nope"}  className="mi_input" type="text" placeholder='Please enter your old password*' />)}
                                                </fieldset>
                                            </Form.Item>
                                        </Col>
                                        <Col sm={24}>
                                            <Form.Item>
                                                <fieldset className="mi_input_pop">
                                                    <legend className="legend-font">New Password  </legend>
                                                    {getFieldDecorator('newpassword', {
                                                        rules: [{ required: true, message: 'Please enter new password.' }],
                                                    })(<Input.Password autoComplete={"nope"}  className="mi_input" type="text" placeholder='Please enter your new password*' />)}
                                                </fieldset>
                                            </Form.Item>
                                        </Col>
                                        <Col sm={24}>
                                            <Form.Item dependencies={['newpassword']}>
                                                <fieldset className="mi_input_pop">
                                                    <legend className="legend-font">Confirm Password  </legend>
                                                    {getFieldDecorator('confirmpassword', {
                                                        rules: [{ required: true, message: 'Please enter confirm password.' },
                                                        {
                                                            validator(rule, value) {
                                                                if (!value || getFieldValue('newpassword') === value) {
                                                                    return Promise.resolve();
                                                                }
                                                                return Promise.reject('passwords that you entered do not match!');
                                                            }
                                                        }],
                                                    })(<Input.Password autoComplete={"nope"}  className="mi_input" type="text" placeholder='Please enter your new password again*' />)}
                                                </fieldset>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row span={24} style={{ marginTop: '20px' }}>
                                        <Col span={7} ></Col>
                                        <Col span={3} >
                                        </Col>
                                        <Col span={5} >
                                            <Button htmlType="submit" type="primary">
                                                Submit
                                            </Button>
                                        </Col>
                                        <Col span={2} >
                                        </Col>
                                        <Col span={7} >
                                            <img alt="example" style={{ width: 105, marginBottom: '-28px', float: 'right' }} src={img} />
                                        </Col>
                                    </Row>
                                </Form>
                            </Col>
                            <Col md={6} sm={24}></Col>
                        </Row>
                    </div>
                </div>
            </Content>
        );
    }
}
const ResetPassword = Form.create()(FD);
export default ResetPassword;